module.exports = __webpack_public_path__ + "static/img/annie.ae2c105.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/annie.jpg
// module id = RXaC
// module chunks = 1